const OPEN_CLASS = "is-open";
const BODY_CLASS = "is-boiler-principle-popup-open";

export default function initBoilerPrinciplePopup() {
  const root = document.getElementById("js-boiler-principle-popup");
  if (!root) return;

  const dialog = root.querySelector(".p-boiler-principle-popup__dialog");
  const panels = [...root.querySelectorAll("[data-popup-panel]")];
  const openButtons = document.querySelectorAll(".js-boiler-principle-popup-open");
  const closeTargets = root.querySelectorAll("[data-popup-close]");

  if (!dialog || panels.length === 0 || openButtons.length === 0) return;

  let activePanel = null;
  let lastFocused = null;

  const getPanel = (id) => panels.find((panel) => panel.dataset.popupPanel === id) ?? null;

  const setTitleId = (panel) => {
    const title = panel?.querySelector(".p-boiler-principle-popup__title");
    if (title) {
      dialog.setAttribute("aria-labelledby", title.id);
    }
  };

  const closePopup = () => {
    root.hidden = true;
    root.classList.remove(OPEN_CLASS);
    document.body.classList.remove(BODY_CLASS);
    dialog.classList.remove("p-boiler-principle-popup__dialog--product");

    panels.forEach((panel) => {
      panel.hidden = true;
    });

    activePanel = null;
    dialog.removeAttribute("aria-labelledby");

    if (lastFocused instanceof HTMLElement) {
      lastFocused.focus();
    }
  };

  const openPopup = (panelId) => {
    const panel = getPanel(panelId);
    if (!panel) return;

    lastFocused = document.activeElement;
    activePanel = panel;

    panels.forEach((item) => {
      item.hidden = item !== panel;
    });

    dialog.classList.toggle(
      "p-boiler-principle-popup__dialog--product",
      panel.dataset.popupType === "product",
    );

    root.hidden = false;
    root.classList.add(OPEN_CLASS);
    document.body.classList.add(BODY_CLASS);
    setTitleId(panel);

    const closeButton = root.querySelector(".p-boiler-principle-popup__close");
    closeButton?.focus();
  };

  openButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const panelId = button.getAttribute("data-popup-target");
      if (!panelId) return;
      openPopup(panelId);
    });
  });

  closeTargets.forEach((target) => {
    target.addEventListener("click", closePopup);
  });

  document.addEventListener("keydown", (event) => {
    if (!root.classList.contains(OPEN_CLASS)) return;

    if (event.key === "Escape") {
      event.preventDefault();
      closePopup();
    }
  });
}
